/* eslint-disable max-len */
import {inputType} from '../../../../../pages/esgManager/interface/inputType';

import {CDP_CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_FIELD_NAMES} from './corporateQuestionsKeys';

export const corporatePerformanceConsolidationApproachQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '6.1 Provide details on your chosen consolidation approach for the calculation of environmental performance data.',
            tooltip: `The consolidation approach is the method by which environmental impacts (e.g., GHG
                      emissions, water withdrawals etc.) have been attributed to your organization. This context will
                      help data users interpret how the environmental impacts relate to your business operations.`
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_FIELD_NAMES.CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_FIELD_NAMES.CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_1_VALUE,
                  fieldLabel: 'Environmental issue',
                  options: [
                    {value: 'Climate change', label: 'Climate change'},
                    {value: 'Forests', label: 'Forests'},
                    {value: 'Water', label: 'Water'},
                    {value: 'Plastics', label: 'Plastics'},
                    {value: 'Biodiversity', label: 'Biodiversity'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_FIELD_NAMES.CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_2_VALUE,
                  fieldLabel: 'Consolidation approach used',
                  options: [
                    {
                      value: 'Operational control',
                      label: 'Operational control'
                    },
                    {value: 'Financial control', label: 'Financial control'},
                    {value: 'Equity share', label: 'Equity share'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_FIELD_NAMES.CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH_Q1_3_VALUE,
                  fieldLabel:
                    'Provide the rationale for the choice of consolidation approach',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      }
    ]
  }
];
